import { HttpContextToken } from '@angular/common/http';

export const USE_AUTH_INTERCEPTOR = new HttpContextToken<boolean>(() => false);
export const USE_OLD_ID_TOKEN_INTERCEPTOR = new HttpContextToken<boolean>(() => false);
